import { Injectable } from '@angular/core';
import { AlertViewModel, ItemsViewModel } from '../../src/typings/api';
import { AppContext } from '../../src/typings/models';
import { LocationLoadedEventService } from '../locationLoaded/LocationLoadedEventService';

@Injectable({
    providedIn: 'root'
})
export class AppContextService {
    public static $name: string = 'appContextService';

    public _appContext: AppContext;

    constructor(
        private locationLoadedEventService: LocationLoadedEventService
    ) {
        /* OBJECT REFERENCE! */
        this._appContext = {
            locationAlerts: {}
        };
    }

    get isLocationLoaded() {
        if (this._appContext.loadedLocationId) {
            return true;
        }

        return false;
    }

    get isModuleLoaded() {
        return this.loadedModuleId && !this.isLocationLoaded;
    }

    get loadedLocationAlerts() {
        return this.getLocationAlerts(this.loadedLocationId);
    }

    get loadedLocationId() {
        return this._appContext.loadedLocationId || 0;
    }

    set loadedLocationId(locationId: number) {
        this._appContext.loadedLocationId = locationId;
    }

    get loadedModuleId() {
        return this._appContext.loadedModuleId || 0;
    }

    set loadedModuleId(moduleId: number) {
        this._appContext.loadedModuleId = moduleId;
    }

    public getLocationAlerts(locationId: number): AlertViewModel[] {
        const locationAlerts = this._appContext.locationAlerts;

        if (locationAlerts && locationAlerts[locationId]) {
            return locationAlerts[locationId];
        }

        return null;
    }

    public unloadLoadedModule() {
        this._appContext.loadedModuleId = null;
    }

    public setLocationAlerts(alerts: Array<ItemsViewModel<AlertViewModel>>) {
        alerts.forEach((alert: ItemsViewModel<AlertViewModel>) => {
            this._appContext.locationAlerts[alert.id] = alert.items;
        });
    }

    public unloadLocation() {
        this.loadedLocationId = null;
        this.locationLoadedEventService.publishUnloaded();
    }

    public updateLocationAlerts(locationId: number, alerts: AlertViewModel[]) {
        this._appContext.locationAlerts[locationId] = alerts;
    }
}
